import { Link } from "react-router-dom";
import { FileText } from "lucide-react";
import SEOHead from "../layout/SEOHead";
import { useCommerce } from "../../context/CommerceContext";

// Shown on /cart and /checkout when COMMERCE_ENABLED=false. Quote path stays fully functional.
export const CommerceUnavailable = ({ title }) => (
  <>
    <SEOHead title={`${title} | Highwall Lift`} description="Request a Highwall Lift quote." canonicalPath="/" />
    <div className="min-h-screen bg-[#0A0A0A] pt-28 pb-24">
      <div className="max-w-3xl mx-auto px-6 sm:px-8">
        <p className="font-mono text-signal-red uppercase tracking-[0.2em] text-xs font-bold mb-3">Highwall Lift</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight uppercase text-white mb-6" data-testid="commerce-unavailable-title">Online Ordering Coming Soon</h1>
        <p className="text-gray-300 mb-8" data-testid="commerce-unavailable-message">Online purchasing is not currently available. Request a quote and a Highwall representative will confirm pricing, shipping and lead time for your order.</p>
        <Link to="/#quote" className="inline-flex items-center gap-2 px-6 py-4 bg-signal-red text-white font-bold uppercase tracking-wide hover:bg-signal-red/90 transition-colors" data-testid="commerce-unavailable-quote">
          <FileText className="w-4 h-4" /> Request a Quote
        </Link>
      </div>
    </div>
  </>
);

// Wraps a commerce page: loading → spinner, disabled → CommerceUnavailable, enabled → page.
export const CommerceGate = ({ title, children }) => {
  const { commerceEnabled } = useCommerce();
  if (commerceEnabled === null) return <div className="min-h-screen bg-[#0A0A0A] pt-28 text-center text-gray-500" data-testid="commerce-loading">Loading…</div>;
  if (!commerceEnabled) return <CommerceUnavailable title={title} />;
  return children;
};
